import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';
import { brand, navLinks, socialLinks } from '../mock';

const Footer = () => {
  return (
    <footer className="relative border-t border-ink-10 bg-[#F6EFE4]">
      <div className="mx-auto max-w-6xl px-5 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-md bg-gradient-to-br from-[#E08C5F] to-[#C2603A] flex items-center justify-center">
                <span className="serif-display text-white text-xl leading-none">E</span>
              </div>
              <span className="text-lg font-medium">{brand.name}</span>
            </div>
            <p className="mt-4 text-muted max-w-md text-[14.5px] leading-relaxed">
              Custom AI solutions, automations, and strategy to help your business save time and scale faster.
            </p>
            <a href={`mailto:${brand.email}`} className="inline-flex items-center gap-2 mt-4 text-[#C2603A] hover:underline">
              <Mail className="w-4 h-4" /> {brand.email}
            </a>
            <div className="mt-4 flex items-center gap-3">
              <a
                href={brand.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-9 h-9 rounded-lg bg-white border border-ink-10 flex items-center justify-center text-ink/70 hover:text-[#C2603A] hover:border-[#C2603A]/40 transition"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href={brand.calendarUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[12.5px] text-muted hover:text-ink"
              >
                Book a call
              </a>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold text-ink">Navigate</div>
            <ul className="mt-3 space-y-2 text-[14px]">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.href} className="text-muted hover:text-ink">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-sm font-semibold text-ink">Follow</div>
            <ul className="mt-3 space-y-2 text-[14px]">
              {socialLinks.map((l) => (
                <li key={l.label}>
                  {l.external ? (
                    <a href={l.href} target="_blank" rel="noopener noreferrer" className="text-muted hover:text-ink">
                      {l.label}
                    </a>
                  ) : (
                    <a href={l.href} className="text-muted hover:text-ink">{l.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-ink-10 flex flex-col md:flex-row items-center justify-between gap-3 text-[13px] text-muted">
          <div>© {new Date().getFullYear()} {brand.name}. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#privacy" className="hover:text-ink">Privacy</a>
            <a href="#terms" className="hover:text-ink">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
